import Work1 from "../../assets/img/vnom_work.png";
import Work2 from "../../assets/img/criptphy_work.png";

export const projectsData =  [
    {
      id: 1,
      image: Work1,
      title: "VNOM - Serviços e Pessoas",
      category: "web",
      link: "https://github.com/VNOM-corporation",
    },
    {
      id: 2,
      image: Work2,
      title: "Criptphy",
      category: "web",
      link: "https://github.com/Criptphy",
    },
];

export const projectsNav = [
    {
        name: 'Todos',
    },
    {
        name: 'Web',
    },
    // {
    //     name: 'app',
    // },
];